module.exports = __webpack_public_path__ + "static/media/krishe-logo.e50c282a.svg";